export const invitationTemplates = {
  rustic: {
    headerFont: "'Playfair Display', serif",
    contentFont: "'Roboto', sans-serif",
    color: '#5D4037',
    backgroundColor: '#F5F5DC',
    borderColor: '#8D6E63',
    borderWidth: '2px',
    borderStyle: 'solid'
  },
  modern: {
    headerFont: "'Montserrat', sans-serif",
    contentFont: "'Open Sans', sans-serif",
    color: '#212121',
    backgroundColor: '#FFFFFF',
    borderColor: '#000000',
    borderWidth: '1px',
    borderStyle: 'solid'
  },
  classic: {
    headerFont: "'Cormorant Garamond', serif",
    contentFont: "'Lora', serif",
    color: '#1A237E',
    backgroundColor: '#FAFAFA',
    borderColor: '#3F51B5',
    borderWidth: '1px',
    borderStyle: 'double'
  },
  elegant: {
    headerFont: "'Cinzel', serif",
    contentFont: "'Raleway', sans-serif",
    color: '#2E1C1C',
    backgroundColor: '#FFF9F9',
    borderColor: '#4A3030',
    borderWidth: '1px',
    borderStyle: 'solid'
  },
  beach: {
    headerFont: "'Amatic SC', cursive",
    contentFont: "'Quicksand', sans-serif",
    color: '#00695C',
    backgroundColor: '#E0F7FA',
    borderColor: '#00897B',
    borderWidth: '2px',
    borderStyle: 'wavy'
  },
  garden: {
    headerFont: "'Josefin Slab', serif",
    contentFont: "'Source Sans Pro', sans-serif",
    color: '#33691E',
    backgroundColor: '#F1F8E9',
    borderColor: '#558B2F',
    borderWidth: '2px',
    borderStyle: 'solid'
  }
}; 